import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})

export class SpinnerComponent implements OnInit {

  @Input() isActive: boolean;

  spinnerMessage: string;

  constructor(private ngxSpinnerService: NgxSpinnerService, private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.translateService.get(['spinner.message'])
      .subscribe(translations => {
        this.spinnerMessage = translations['spinner.Message'];
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isActive) {
      this.toggleSpinner();
    }
  }

  toggleSpinner() {
    if (this.isActive) {
      this.ngxSpinnerService.show();
    } else {
      this.ngxSpinnerService.hide();
    }
  }
}
